"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGroupField = exports.GroupDef = void 0;
const tslib_1 = require("tslib");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = tslib_1.__importStar(require("io-ts"));
const utils_1 = require("../utils");
const NestableDef_1 = require("./nestable/NestableDef");
const GroupDefType = "Group";
const codec = t.strict({
    name: t.string,
    fields: t.array(NestableDef_1.NestableDef),
});
exports.GroupDef = new t.Type("GroupDef", (u) => (0, utils_1.isFieldDef)(u) && u.def.type === GroupDefType, (u) => {
    return (0, function_1.pipe)(codec.decode(u), fp_ts_1.either.map(({ name, fields }) => ({
        key: name,
        def: {
            type: GroupDefType,
            fields: fields.reduce((acc, field) => ({ ...acc, [field.key]: field.def }), {}),
        },
    })));
}, (n) => n);
function fromGroupField(def) {
    var _a;
    return {
        type: GroupDefType,
        fields: Object.entries(((_a = def.config) === null || _a === void 0 ? void 0 : _a.fields) || {}).reduce((acc, [key, f]) => {
            return { ...acc, [key]: (0, NestableDef_1.fromNestableField)(f) };
        }, {}),
    };
}
exports.fromGroupField = fromGroupField;
